// FamilyDashboard.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useFamily } from '../context/FamilyContext';
import MySidebarFamily from './viewsFamily/MySiderbarFamily'; 
import './FamilyDashboard.css';

function FamilyDashboard() {
    const { children, childrenLoading } = useFamily();

    if (childrenLoading) {
        return <div>Loading..........</div>;
    }

    return (
        <div className="app-container">
            <MySidebarFamily/>
            <div className="main-content">
                <Outlet />
            </div>
        </div>
    );
}

export default FamilyDashboard;